import { render, staticRenderFns } from "./QuotientEdit.vue?vue&type=template&id=fafd3b24&scoped=true"
import script from "./QuotientEdit.vue?vue&type=script&lang=js"
export * from "./QuotientEdit.vue?vue&type=script&lang=js"
import style0 from "./QuotientEdit.vue?vue&type=style&index=0&id=fafd3b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafd3b24",
  null
  
)

export default component.exports